import { getProvider } from '../../../../../../helpers/getters';
import { getSelectedService } from '../../../helper';

export default (form, providerForm) => {
  const { provider_id, provider_service_id, mode } = form;
  if (mode) {
    const provider = getProvider(provider_id);
    const isLabel13 = provider ? (provider.form === false) : false;
    let isCancel = false;
    /**
     * Исключение label 13
     * При label 13 providerForm отсутсвует
     * и мы смотрим на настройки в providers
     */
    if (isLabel13) {
      return provider.cancel;
    }
    /**
     * Если есть cancel = true в провайдере или в сервисе service_cancel = true,
     * то показываем
     */
    if (provider_service_id) {
      const selectedService = getSelectedService(provider_service_id, providerForm);
      if (selectedService?.hasOwnProperty('service_cancel')) {
        if (selectedService.service_cancel) {
          isCancel = true;
        }
      }
    }
    if (provider_id) {
      const provider = getProvider(provider_id);
      if (provider?.hasOwnProperty('cancel')) {
        if (provider.cancel) {
          isCancel = true;
        }
      }
    }
    return isCancel;
  }
  // Теперь всегда для Manual показываем Cancel
  // const serviceType = getServiceType(service_type);
  // if (serviceType && serviceType?.hasOwnProperty('cancel')) {
  //   return serviceType.cancel;
  // }

  return true;
};
